module.exports = __webpack_public_path__ + "media/e_video_proof.5bab81fc.mp4";